module.exports = __webpack_public_path__ + "static/media/mobile-header-bg.52dc365f.bin";